<template>
  <fts-design-modal
    class="fts-widget-design-modal"
    ref="ftsWidgetDesignModal"
  >
    <!-- title -->
    <template #title>
      <div class="design-modal-header-std__title">
        <div class="design-modal-header-name design-modal-header-name--flex-1">
          Select a widget to add
        </div>
      </div>
    </template>
    <!-- description -->
    <template #description>
      <span class="design-modal-header-tag">Widget</span>
    </template>
    <!-- body -->
    <template #body>
      <div class="d-widget-design-card" @click="openShortcutDesign">
        <div class="d-widget-design-card-title">
          <font-awesome-icon
            :icon="['fas', 'share-from-square']"
            fixed-width
            class="d-widget-design-card-title-icon"
          /> 
          <span>Shortcut</span>
        </div>
        <font-awesome-icon :icon="['fas', 'angle-right']" />
      </div>

      <div class="d-widget-design-card" @click="openChartDesign">
        <div class="d-widget-design-card-title">
          <font-awesome-icon
            :icon="['fas', 'chart-simple']"
            fixed-width
            class="d-widget-design-card-title-icon"
          /> 
          <span>Chart</span>
        </div>
        <font-awesome-icon :icon="['fas', 'angle-right']" />
      </div>

      <div class="d-widget-design-card" @click="openPredefinedDesign">
        <div class="d-widget-design-card-title">
          <font-awesome-icon
            :icon="['fas', 'table-cells-large']"
            fixed-width
            class="d-widget-design-card-title-icon"
          /> 
          <span>Predefined Card</span>
        </div>
        <font-awesome-icon :icon="['fas', 'angle-right']" />
      </div>
    </template>
    <!-- footer:right -->
    <template #footerRight>
      <!-- cancel -->
      <fts-btn
        text
        @click="reset"    
      >
        Cancel
      </fts-btn>
    </template>
  </fts-design-modal>
</template>

<script>
import FTSDesignModal from "../../design/FTSDesignModal";
import FTSBtn from "../../elements/FTSBtn";

export default {
  components: {
    "fts-design-modal": FTSDesignModal,
    "fts-btn": FTSBtn,
  },
  data: () => ({
    resolve: null,
  }),
  methods: {
    async show() {
      return new Promise((resolve) => {
        this.resolve = resolve;
        this.$refs.ftsWidgetDesignModal.show();
      });
    },
    done(type) {
      this.resolve && this.resolve(type);
      this.reset();
    },
    reset() {
      this.$refs.ftsWidgetDesignModal.close();
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    openShortcutDesign() {
      this.done('shortcut');
    },
    openChartDesign() {
      this.done('chart');
    },
    openPredefinedDesign() {
      this.done('predefined');
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-widget-design-modal {
  .d-widget-design-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
    padding: 1rem 1.5rem;
    border-radius: 0.5rem;
    box-shadow: var(--fts-elevation-2);
    background-color: var(--fts-card-background);
    cursor: pointer;
    &:hover {
      background-color: var(--fts-gray-100);
    }
    .d-widget-design-card-title {
      font-weight: 500;
      font-size: 1.125rem;
      line-height: 1.75rem;
    }
    .d-widget-design-card-title-icon {
      margin-right: 0.25rem;
    }
  }
}
</style>